import { 
  EDI_FILTER_NPI_DATA_LOADING, 
  EDI_FILTER_NPI_DATA_SUCCESS, 
  EDI_FILTER_NPI_DATA_FAILURE,
  EDI_FILTER_STATE_DATA_LOADING, 
  EDI_FILTER_STATE_DATA_SUCCESS, 
  EDI_FILTER_STATE_DATA_FAILURE,
  EDI_FILTER_MARKET_DATA_LOADING,
  EDI_FILTER_MARKET_DATA_SUCCESS,
  EDI_FILTER_MARKET_DATA_FAILURE,
  EDI_FILTER_TIN_DATA_LOADING,
  EDI_FILTER_TIN_DATA_SUCCESS,
  EDI_FILTER_TIN_DATA_FAILURE
} from "@src/middleware/actions/actionTypes";


interface SmartEditsState {
  ediFilterNPIData: any;
  ediFilterNPIIsLoading: boolean;
  ediFilterNPIError: string | null;
  ediFilterStateData: any;
  ediFilterStateIsLoading: boolean;
  ediFilterStateError: string | null;
  ediFilterMarketData: any;
  ediFilterMarketIsLoading: boolean;
  ediFilterMarketError: string | null;
  ediFilterTinData: any;
  ediFilterTinIsLoading: boolean;
  ediFilterTinError: string | null;
}

const initialState: SmartEditsState = {
  ediFilterNPIData: {},
  ediFilterNPIIsLoading: false,
  ediFilterNPIError: null,
  ediFilterStateData: {},
  ediFilterStateIsLoading: false,
  ediFilterStateError: null,
  ediFilterMarketData: {},
  ediFilterMarketIsLoading: false,
  ediFilterMarketError: null,
  ediFilterTinData: {},
  ediFilterTinIsLoading: false,
  ediFilterTinError: null,
};

const EditfilterReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): SmartEditsState => {
  switch (action.type) {
    case EDI_FILTER_NPI_DATA_LOADING:
      return {
        ...state,
        ediFilterNPIIsLoading: action.payload,
      };

    case EDI_FILTER_NPI_DATA_SUCCESS:
      return {
        ...state,
        ediFilterNPIData: action.payload,
      };

    case EDI_FILTER_NPI_DATA_FAILURE:
      return {
        ...state,
        ediFilterNPIError: action.payload,
      };
    
    case EDI_FILTER_STATE_DATA_LOADING:
      return {
        ...state,
        ediFilterStateIsLoading: action.payload,
      };

    case EDI_FILTER_STATE_DATA_SUCCESS:
      return {
        ...state,
        ediFilterStateData: action.payload,
      };

    case EDI_FILTER_STATE_DATA_FAILURE:
      return {
        ...state,
        ediFilterStateError: action.payload,
      };

    case EDI_FILTER_MARKET_DATA_LOADING:
      return {
        ...state,
        ediFilterMarketIsLoading: action.payload,
      };

    case EDI_FILTER_MARKET_DATA_SUCCESS:
      return {
        ...state,
        ediFilterMarketData: action.payload,
      };

    case EDI_FILTER_MARKET_DATA_FAILURE:
      return {
        ...state,
        ediFilterMarketError: action.payload,
      };

    case EDI_FILTER_TIN_DATA_LOADING:
      return {
        ...state,
        ediFilterTinIsLoading: action.payload,
      };

    case EDI_FILTER_TIN_DATA_SUCCESS:
      return {
        ...state,
        ediFilterTinData: action.payload,
      };

    case EDI_FILTER_TIN_DATA_FAILURE:
      return {
        ...state,
        ediFilterTinError: action.payload,
      };

    default:
      return state;
  }
};

export default EditfilterReducer;
